import * as React from "react";
import PrintWidget from "common/components/widgetRenderers/PrintWidget";
const ExportingWidget = ({ widget, value, height = void 0, width = void 0 }) => /* @__PURE__ */ React.createElement(
  PrintWidget,
  {
    widget,
    widgetId: widget == null ? void 0 : widget.search_type_id,
    value,
    showCaption: true,
    showHeading: true,
    showHandle: false,
    height,
    width,
    interactive: false,
    limitHeight: false,
    hideDescription: true,
    hideQuery: true
  }
);
export default ExportingWidget;
